export const PATRIMONY_FETCH_INIT = 'PATRIMONY_FETCH_INIT';
export const PATRIMONY_FETCH_SUCCESS = 'PATRIMONY_FETCH_SUCCESS';
export const PATRIMONY_FETCH_ERROR = 'PATRIMONY_FETCH_ERROR';

export const PATRIMONY_POST_INIT = 'PATRIMONY_POST_INIT';
export const PATRIMONY_POST_SUCCESS = 'PATRIMONY_POST_SUCCESS';
export const PATRIMONY_POST_ERROR = 'PATRIMONY_POST_ERROR';

export const PATRIMONY_RESET = 'PATRIMONY_RESET';
